/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { Typography } from "@insite/mobius/index";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mergeWithCss } from "@monsma/XDL/Utilities";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    className?: string;
    messageName?: string;
    extendedStyles?: MessagePanelStyles;
}

export interface MessagePanelStyles {
    wrapper?: InjectableCss;
    content?: TypographyPresentationProps;
}

export const messagePanelStyles: MessagePanelStyles = {
    wrapper: {
        css: css`
            border-radius: 6px;
            background: ${getColor("common.ui21")};
            padding: 10px;
        `,
    },
    content: {
        lineHeight: "16px",
        size: "10px",
        css: css`
            margin-bottom: 0;

            a {
                span {
                    font-size: 10px;
                }
            }
        `,
    },
};

const MessagePanel = ({ className, messageName, extendedStyles }: OwnProps) => {
    const [styles] = useState(() => mergeWithCss(messagePanelStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.wrapper} className={className}>
            <Typography {...styles.content} variant="p">
                {siteMessage(`${messageName}`)}
            </Typography>
        </StyledWrapper>
    );
};

export default MessagePanel;
